import axios from 'axios';
// import qs from 'qs';

class Http {
  constructor(urlConfiguration) {
    if (!['POST', 'PUT', 'DELETE', 'GET'].includes(urlConfiguration.method)) throw new Error('method not valid');

    this.url = urlConfiguration.full_url;
    this.method = urlConfiguration.method;
  }

  fetch(props) {
    const {
      data = {},
      headers = {},
      success = () => {},
      error = () => {},
    } = props;

    headers.Authorization = `Token ${localStorage.getItem('token')}`;

    // if (this.method === 'GET') this.url = `${this.url}?${qs.stringify(data)}`;

    // Se pasa por la autentificación Y se compone la Configuración del Axios
    const axiosConfiguration = {
      method: this.method,
      url: this.url,
      headers,
      [this.method === 'GET' ? 'params' : 'data']: data,
    };

    // if (this.method !== 'GET') axiosConfiguration.data = data;

    return new Promise((resolve, reject) => {
      axios(axiosConfiguration)
        .then((response) => {
          success(response.data);
          resolve(response.data);
        })
        .catch((response) => {
          error(response.response?.data);
          reject(response.response?.data);
        });
    });
  }
}

export default Http;
